import {MagentoItem} from './MagentoItem';

export class Gift extends MagentoItem {
  constructor(item: MagentoItem) {
    super(item.getData());
  }
}
